export * from 'SourceStore/Product/Product.action';

export const UPDATE_PRODUCT_TRACKER_VARIABLES = 'UPDATE_PRODUCT_TRACKER_VARIABLES';

/**
 * Update variant for PDP configurator
 * @namespace Pwa/Store/Product/Action/updateProductTrackerVariables */
export const updateProductTrackerVariables = (trackerVariables) => ({
    type: UPDATE_PRODUCT_TRACKER_VARIABLES,
    trackerVariables,
});
